module.exports = "<router-outlet></router-outlet>\n"


//////////////////
// WEBPACK FOOTER
// C:/Users/Artem/Desktop/Programming/studio/creativeDigital/src/app/app.component.html
// module id = ../../../../../src/app/app.component.html
// module chunks = 0